import { render, staticRenderFns } from "./tcDivideManager.vue?vue&type=template&id=645d7b6e&scoped=true&"
import script from "./tcDivideManager.vue?vue&type=script&lang=js&"
export * from "./tcDivideManager.vue?vue&type=script&lang=js&"
import style0 from "./tcDivideManager.vue?vue&type=style&index=0&id=645d7b6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d7b6e",
  null
  
)

export default component.exports